import { trackEvent } from '@/utils/track/index'

/**
 * 优惠代码页面加载
 */
export function promoCodesPageLoadEv(val: { havecode: string }) {
  trackEvent({
    eventid: 11881,
    category: 'Promo Codes',
    label: 'pageload',
    action: 'show',
    value: {
      havecode: val.havecode,
    },
  })
}

/**
 * 优惠代码兑换点击
 */
export function promoCodeRedeemClickEv(val: { promoCode: string }) {
  trackEvent({
    eventid: 11882,
    category: 'Promo Codes',
    label: 'Add',
    action: 'click',
    value: {
      PromoCode: val.promoCode,
    },
  })
}

/**
 * 优惠代码去使用
 */
export function promoCodeUseClickEv(val: { promoCode: string }) {
  trackEvent({
    eventid: 12460,
    category: 'Promo Codes',
    label: 'GoToUse',
    action: 'click',
    value: {
      PromoCode: val.promoCode,
    },
  })
}
